import React, { useState } from 'react';
import { useHRMS } from '../context/HRMSContext.jsx';

function Reports() {
  const { state } = useHRMS();
  const [reportType, setReportType] = useState('worker');         
  const [dateRange, setDateRange] = useState({
    startDate: new Date().toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0]
  });

  const generateWorkerReport = () => {
    const workers = state.workers || [];
    const departmentWise = workers.reduce((acc, worker) => {
      acc[worker.department] = (acc[worker.department] || 0) + 1;
      return acc;
    }, {});

    return {
      totalWorkers: workers.length,
      departmentWise,
      avgSalary: workers.length > 0 ? workers.reduce((sum, worker) => sum + parseFloat(worker.salary || 0), 0) / workers.length : 0
    };
  };  

  const generateAttendanceReport = () => {
    const attendance = state.attendance || [];
    const filteredAttendance = attendance.filter(att => 
      att.date >= dateRange.startDate && att.date <= dateRange.endDate
    );

    const statusWise = filteredAttendance.reduce((acc, att) => {
      acc[att.status] = (acc[att.status] || 0) + 1;
      return acc;
    }, {});

    return {
      totalRecords: filteredAttendance.length,
      statusWise,
      attendanceRate: ((statusWise[0] || 0) / filteredAttendance.length * 100).toFixed(2)
    };
  };

  const generateLeaveReport = () => { 
    const leaves = state.leaves || [];
    const filteredLeaves = leaves.filter(leave => 
      leave.startDate >= dateRange.startDate && leave.endDate <= dateRange.endDate
    );

    const typeWise = filteredLeaves.reduce((acc, leave) => {
      acc[leave.type] = (acc[leave.type] || 0) + 1;
      return acc;
    }, {});

    const statusWise = filteredLeaves.reduce((acc, leave) => {
      acc[leave.status] = (acc[leave.status] || 0) + 1;
      return acc;
    }, {});

    return {
      totalLeaves: filteredLeaves.length,
      typeWise,
      statusWise
    };
  };

  const generatePayrollReport = () => {
    const workers = state.workers || [];
    const totalPayroll = workers.reduce((sum, emp) => {
      const basicSalary = parseFloat(emp.salary);
      const hra = basicSalary * 0.4;
      const da = basicSalary * 0.1;
      const grossSalary = basicSalary + hra + da;
      const pf = basicSalary * 0.12;
      const tax = grossSalary > 50000 ? grossSalary * 0.1 : 0;
      const netSalary = grossSalary - pf - tax;
      
      return {
        totalBasic: sum.totalBasic + basicSalary,
        totalGross: sum.totalGross + grossSalary,
        totalDeductions: sum.totalDeductions + pf + tax,
        totalNet: sum.totalNet + netSalary
      };
    }, { totalBasic: 0, totalGross: 0, totalDeductions: 0, totalNet: 0 });

    return totalPayroll;
  };

  const renderReport = () => {
    switch(reportType) {
      case 'Worker':
        const WorkerReport = generateWorkerReport();
        return (
          <div>
            <h5>Worker Report</h5>
            <div className="row">
              <div className="col-md-4">
                <div className="card bg-primary text-white">
                  <div className="card-body">
                    <h6>Total Workers </h6>
                    <h4>{WorkerReport.totalWorkers}</h4>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card bg-success text-white">
                  <div className="card-body">
                    <h6>Average Salary</h6>
                    <h4>₹{WorkerReport.avgSalary.toFixed(0)}</h4>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card bg-info text-white">
                  <div className="card-body">
                    <h6>Departments</h6>
                    <h4>{Object.keys(WorkerReport.departmentWise).length}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4">
              <h6>Department-wise Distribution</h6>
              <table className="table">
                <thead>
                  <tr>
                    <th>Department</th>
                    <th>Worker Count</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(WorkerReport.departmentWise).map(([dept, count]) => (
                    <tr key={dept}>
                      <td>{dept}</td>
                      <td>{count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );

      case 'attendance':
        const attReport = generateAttendanceReport();
        return (
          <div>
            <h5>Attendance Report</h5>
            <div className="row">
              <div className="col-md-4">
                <div className="card bg-primary text-white">
                  <div className="card-body">
                    <h6>Total Records</h6>
                    <h4>{attReport.totalRecords}</h4>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card bg-success text-white">
                  <div className="card-body">
                    <h6>Attendance Rate</h6>
                    <h4>{attReport.attendanceRate}%</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4">
              <h6>Status-wise Distribution</h6>
              <table className="table">
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(attReport.statusWise).map(([status, count]) => (
                    <tr key={status}>
                      <td>{status === '0' ? '0-Present' : status === '1' ? '1-Absent' : status === '2' ? '2-Late' : status === '3' ? '3-Half Day' : status}</td>
                      <td>{count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );

      case 'leave':
        const leaveReport = generateLeaveReport();
        return (
          <div>
            <h5>Leave Report</h5>
            <div className="row">
              <div className="col-md-4">
                <div className="card bg-primary text-white">
                  <div className="card-body">
                    <h6>Total Leaves</h6>
                    <h4>{leaveReport.totalLeaves}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-6">
                <h6>Leave Type Distribution</h6>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(leaveReport.typeWise).map(([type, count]) => (
                      <tr key={type}>
                        <td>{type}</td>
                        <td>{count}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="col-md-6">
                <h6>Status Distribution</h6>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(leaveReport.statusWise).map(([status, count]) => (
                      <tr key={status}>
                        <td>{status === '0' ? '0-Pending' : status === '1' ? '1-Approved' : status === '2' ? '2-Rejected' : status}</td>
                        <td>{count}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );

      case 'payroll':
        const payrollReport = generatePayrollReport();
        return (
          <div>
            <h5>Payroll Report</h5>
            <div className="row">
              <div className="col-md-3">
                <div className="card bg-primary text-white">
                  <div className="card-body">
                    <h6>Total Basic</h6>
                    <h4>₹{payrollReport.totalBasic.toFixed(0)}</h4>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card bg-success text-white">
                  <div className="card-body">
                    <h6>Total Gross</h6>
                    <h4>₹{payrollReport.totalGross.toFixed(0)}</h4>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card bg-warning text-white">
                  <div className="card-body">
                    <h6>Total Deductions</h6>
                    <h4>₹{payrollReport.totalDeductions.toFixed(0)}</h4>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card bg-info text-white">
                  <div className="card-body">
                    <h6>Total Net</h6>
                    <h4>₹{payrollReport.totalNet.toFixed(0)}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return <div>Select a report type</div>;
    }
  };

  return (
    <div className="reports">
      <h2>Reports & Analytics</h2>
      
      <div className="row mb-4">
        <div className="col-md-3">
          <label className="form-label">Report Type</label>
          <select 
            className="form-control"
            value={reportType}
            onChange={(e) => setReportType(e.target.value)}
          >
            <option value="worker">Worker Report</option>
            <option value="attendance">Attendance Report</option>
            <option value="leave">Leave Report</option>
            <option value="payroll">Payroll Report</option>
          </select>
        </div>
        {(reportType === 'attendance' || reportType === 'leave') && (
          <>
            <div className="col-md-3">
              <label className="form-label">Start Date</label>
              <input
                type="date"
                className="form-control"
                value={dateRange.startDate}
                onChange={(e) => setDateRange({...dateRange, startDate: e.target.value})}
              />
            </div>
            <div className="col-md-3">
              <label className="form-label">End Date</label>
              <input
                type="date"
                className="form-control"
                value={dateRange.endDate}
                onChange={(e) => setDateRange({...dateRange, endDate: e.target.value})}
              />
            </div>
          </>
        )}
      </div>

      <div className="card">
        <div className="card-body">
          {renderReport()}
        </div>
      </div>
    </div>
  );
}

export default Reports;